import React from 'react'
import { Layout } from '../../../../components'
import Colors from './colors'
import Header from '../../../../components/header'

import data from './data.json'

export default props => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Colors />
      </Layout>
    </>
  )
}
